<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<ymqcList></ymqcList>
		</div>
		<div class="add" v-if="type==='add'">
			<ymqcAdd></ymqcAdd>
		</div>
		<div class="add" v-if="type==='edit'">
			<ymqcEdit></ymqcEdit>
		</div>
		<div class="add" v-if="type==='see'">
			<ymqcSee></ymqcSee>
		</div>
		<div class="list" v-if="type==='packageList'">
			<ymqcPackageList></ymqcPackageList>
		</div>
	</div>
</template>
<script>
	import ymqcList from "../comp/ymqc_list.vue"
	import ymqcAdd from "../comp/ymqc_add.vue"
	import ymqcEdit from "../comp/ymqc_edit.vue"
	import ymqcSee from "../comp/ymqc_see.vue"
	import ymqcPackageList from "../comp/ymqcPackage_list.vue"
	export default {
		components:{ymqcList,ymqcAdd,ymqcEdit,ymqcSee,ymqcPackageList},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yiliaoxin.ymqcParams.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	width:100%;
	height: calc(100% - 145px);margin-top:12px;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
